import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/app/layouts/admin.vue").then(m => m.default || m)),
  auth: defineAsyncComponent(() => import("/app/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  fullpage: defineAsyncComponent(() => import("/app/layouts/fullpage.vue").then(m => m.default || m)),
  situation: defineAsyncComponent(() => import("/app/layouts/situation.vue").then(m => m.default || m))
}